module.exports = __webpack_public_path__ + "static/media/visa-color.6f6736ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/visa-color.svg
// module id = 860
// module chunks = 7